import { Goal } from "@raskrask-dk/raskrask-utils";
import type CompanyLeadState from "..";
import {Action} from "../../../action/action";


export class SetGoal extends Action<"SET_GOAL", Goal> {
  readonly type = "SET_GOAL";
  protected state: CompanyLeadState;

  constructor(state: CompanyLeadState, data?: Goal) {
    super(state, data);
    this.state = state;
  }

  public isValid(): boolean {
    return this.isDoable();
  }

  /**
   *
   * @returns whether the user can set the goal for a one time booking
   *
   * Business logic:
   * The user can do this as long as the companytype is a onetime booking.
   */
  public isDoable(): boolean {
    const {product} = this.state.bookingflowStateMachine.getData();
    return product.type === "Booking";
  }
}
